import Header from "../components/dynamic/Header";
import Badge from "../components/dynamic/Badge";

const TimeoutView = () => {
  return (
    <div className="flex flex-col items-center">
      <Header
        title="Timeout"
        subheader="Your session has timed out, please refresh the page to try again"
      />

      <div className="flex flex-col gap-3 mb-6 w-full">
        <div className="flex items-start gap-2">
          <div className="mt-1 w-[80px] flex justify-start">
            <Badge text="Session" />
          </div>
          <span className="text-sm text-text-secondary dark:text-text-secondary-dark flex-1">
            Your connection was interrupted or has exceeded the maximum allowed
            time.
          </span>
        </div>

        <div className="flex items-start gap-2">
          <div className="mt-1 w-[80px] flex justify-start">
            <Badge text="Action" />
          </div>
          <span className="text-sm text-text-secondary dark:text-text-secondary-dark flex-1">
            Refreshing the page will establish a new session and let you
            continue.
          </span>
        </div>
      </div>
    </div>
  );
};

export default TimeoutView;
